import React from "react";
import { Redirect } from "react-router-dom";
import useSession from "Utils/Hooks/useSession";
import { FaroRoute } from "@grafana/faro-react";

/**
 * @param {{component:React.Component, appProps:any, ...rest:any}}
 * @param component Component to render if criteria is met.
 * @param appProps Additional props to pass to the component.
 * @param rest RouteProps
 */
export default function TransactionRoute({ component: C, appProps, ...rest }) {
  const { session } = useSession();
  const isEnrolled = session && !session.isExpired && session.isVipEnrolled;
  const hasTransacted = session?.transactionSucceeded;
  if (session) {
    return (
      <FaroRoute
        {...rest}
        render={(props) =>
          isEnrolled && !hasTransacted ? (
            <C {...props} {...appProps} />
          ) : (
            <Redirect to="/dashboard" />
          )
        }
      />
    );
  }
}
